export const cleanSrcValue = val => {
  if (val) {
    return val.replace(/^"|"$/g, '');
  } else return null;
};
